import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Label, List, Message, Segment } from "semantic-ui-react";
import styles  from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/medical/";

const MonitoringChangesLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0,1,2,3]);

const renderAccordionUnderstanding = () => {
  return (
    <>
    <Segment raised className={styles.segmentWhiteBG} > 
      <p className={styles.learnMoreAccordionText} >
      As we get older, our functional status changes. It is important to monitor any changes in functional status of the older adult and adjust their living situation based on these changes.      
        <br/><br/>
        The findings may indicate that plans need to be made to ensure the older adult's safety and well-being, such as making new housing arrangements or getting in-home assistance.       
        <br/><br/>
        <span className={styles.learnMoreAccordionTextEmphasis} >
        Older people with the same medical diagnoses can have significantly different lifestyles.
        </span>
        <br/><br/>
        One might be a Supreme Court justice who lives in his own home, while the other lives a life of dependency in a nursing home. The higher functional status of the judge allows him to have a more actively engaged life, even though they are both the same age.
      </p>
    </Segment>
    </>
  );
};
const renderAccordionMeasuring = () => {
  return (
    <>
    <Grid stackable doubling columns="equal" padded='vertically'>
      <Grid.Column stretched>
        <Segment raised className={styles.highlightsItemWhiteBG} >  
          <List divided relaxed bulleted className={styles.learnMoreBulletedList}  >
            <List.Header className={styles.learnMoreBulletedListHeader} >Activities of Daily Living (ADL):</List.Header>
            <>
              <List.Item description="Bathing" />
              <List.Item description="Dressing" />
              <List.Item description="Grooming" />
              <List.Item description="Continence" />
              <List.Item description="Eating" />
              <List.Item description="Mobility" style={{bottomBorder: "none"}}/>
            </>
          </List>
        </Segment>
      </Grid.Column>
      <Grid.Column width={7} stretched>
        <Segment raised className={styles.highlightsItemWhiteBG} >  
          <div style={{width: '100%', height: '100%', display: "inline-block", marginTop: '1rem'}}>
            <p className={styles.learnMoreAccordionText} style={{marginLeft: '1rem'}} > <br/>
              The lists displayed are <b>Activities of Daily Living (ADLs)</b> and <b>Instrumental Activities 
              of Daily Living (IADLs)</b> which are the tasks and activities used to measure functional status.</p>
            <div className={styles.learnMoreQuoteBox}>
              <Icon name="key" className={styles.learnMoreTipTopLeftIcon} />
              <span className={styles.learnMoreQuoteBoxSpan}>
                <Header className={styles.learnMoreTipHeaderWithTopLeftIcon} content="Keys for Success:" />
                <p className={styles.learnMoreNoticeText} > It may be helpful to keep this list handy and use it 
                  as a reference to evaulate if there are any changes. </p>
              </span>
            </div>
          </div>
        </Segment>
      </Grid.Column>
      <Grid.Column stretched>
        <Segment raised className={styles.highlightsItemWhiteBG} >  
          <List divided relaxed bulleted className={styles.learnMoreBulletedList}  >
            <List.Header className={styles.learnMoreBulletedListHeader} >Instrumental Activities of Daily Living (IADL):</List.Header>
            <>
              <List.Item description="Housekeeping" />
              <List.Item description="Laundry" />
              <List.Item description="Meal Prep" />
              <List.Item description="Medication Management" />
              <List.Item description="Money Management" />
              <List.Item description="Shopping" />
              <List.Item description="Telephone Use" />
              <List.Item description="Transportation" style={{bottomBorder: "none"}}/>
            </>
          </List>
        </Segment>
      </Grid.Column>
    </Grid>
    </>
  );
};

const accordions = [
  { key: 'understanding',
    index: 0,
    title: { 
      icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
      content: <Label className={styles.learnMoreAccordionLabelTitle} > Understanding Functional Status </Label> },
    content: { 
      content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionUnderstanding()}/>)
    }
  },
  { key: 'measured',
    index: 1,
    title: { 
      icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
      content: <Label className={styles.learnMoreAccordionLabelTitle} > Measuring Functional Status: </Label> },
    content: { 
      content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionMeasuring()} />)
    }
  }
];

return (
  <>
    <Segment className={styles.learnMoreBackgroundImg} style={{ backgroundImage: `url(${cdnRoute}MonitoringLearnMore1.png)`, }}>
      <div className={styles.learnMoreModalContent}  >

        <Grid stackable stretched style={{width: '99.5%'}}>
          <Grid.Row columns="equal" stretched>
            <Grid.Column stretched>
              <div className={styles.learnMoreQuoteBox}>
                <Icon name="pin" className={styles.learnMoreNoticeIcon} />
                <span className={styles.learnMoreQuoteBoxSpan}>
                  <p className={styles.learnMoreNoticeText} > <b>Functional status</b> refers to what a person can 
                      do and is used to determine the capacity for independent living.</p>
                </span>
              </div>
            </Grid.Column>

            <Grid.Column stretched>
              <div className={styles.learnMoreQuoteBox}>
                <Icon name="pin" className={styles.learnMoreNoticeIcon} />
                <span className={styles.learnMoreQuoteBoxSpan}>
                  <p className={styles.learnMoreNoticeText} > Good care addresses a person's individual 
                    functional status while allowing the person to enjoy as normal of a lifestyle as possible.</p>
                </span>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <div className={styles.learnMoreAccordionFullDivGrid} >
          <div className={styles.learnMoreAccordionFullDiv} >
            <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
          </div> 
        </div>   

      </div>
    </Segment>    
  </>
  );  
};

export default observer(MonitoringChangesLearnMore);
